import { DefaultViewOptions } from "../default-view-options/default-view-options";
import { MenuOption } from "../../../../../../shared/domain/entities";
import dayjs from "dayjs";
import { useAuth } from "../../../../../../public/auth/infrastructure/store/auth-context";
import { useNavigation } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import {
  ClockIcon,
  EdgeLogoIcon,
  Modal,
  Particles,
  VerticalEllipsisIcon,
  useDisclosure,
} from "../../../../../../shared/infrastructure/ui";
import { Menu, MenuItem } from "@material-ui/core";
import React, { useMemo, useState } from "react";

export const Header: React.FC = () => {
  const { isOpen, close, open } = useDisclosure();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user } = useAuth();
  const [t] = useTranslation("global");
  const navigation = useNavigation();

  const userOptions: Array<MenuOption & { onClick: () => void }> = useMemo(
    () => [
      {
        value: "profile",
        label: "Profile",
        onClick: () => navigation.navigate("profile"),
      },
      { value: "defaultView", label: "Default View", onClick: open },
    ],
    [open, navigation]
  );

  const offset = user?.timezone?.timezone
    ? dayjs().tz(user.timezone.timezone).utcOffset() / 60
    : dayjs().utcOffset() / 60;

  return (
    <React.Fragment>
      <Particles className="h-[98px] w-screen  md:h-[72px] lg:h-[72px] xl:h-[72px] 2xl:h-[72px]" />
      <div className="z-30 mt-[-98px] flex h-[98px] w-screen items-center overflow-auto  md:mt-[-72px] md:h-[72px]   md:justify-start lg:mt-[-72px] lg:h-[72px] lg:justify-start xl:mt-[-72px] xl:h-[72px]  xl:justify-center 2xl:mt-[-72px] 2xl:h-[72px]">
        <section className=" flex  h-[72px]  w-full overflow-auto md:mx-auto md:w-auto">
          <section className="group mx-5 flex w-full  justify-between  text-[12px] text-white md:mr-0 md:ml-[100px] md:w-[648px] lg:w-[906px] xl:ml-[75px] xl:w-[1086px] 2xl:w-[1450px]">
            <div className=" mt-[20px] flex items-center md:mt-0">
              <EdgeLogoIcon fill="#FFFF" width={45} height={45} />
              <span className="mb-[3px]  ml-[16px] text-[16px] font-[500] text-white">
                Edge Logistics
              </span>
            </div>
            <div className="mb-[15px] flex flex-col-reverse md:mb-0 md:flex-row">
              <button
                className="  ml-[75px] flex cursor-pointer items-center md:ml-[24px]"
                onClick={(event: React.MouseEvent<HTMLElement>): void => {
                  setAnchorEl(event.currentTarget);
                }}
              >
                <span className="mr-[10px]">
                  <img
                    src={user?.avatar}
                    alt=""
                    className="  h-[24px] w-[24px] rounded "
                  />
                </span>
                <div className="mr-[10px] hidden flex-col items-center justify-start md:flex ">
                  <span className="ml-[5px] font-[700] text-white">
                    {user?.name}
                  </span>
                  <span className="ml-[5px] text-[8px]  text-white">
                    {user?.role.name}
                  </span>
                </div>
                <VerticalEllipsisIcon fill="#FFF" width={24} height={24} />
              </button>
              <Menu
                id="basic-menu"
                open={Boolean(anchorEl)}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={() => setAnchorEl(null)}
                anchorEl={anchorEl}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {userOptions.map((item) => (
                  <MenuItem
                    key={item.value}
                    onClick={() => {
                      item.onClick();
                      setAnchorEl(null);
                    }}
                  >
                    <section className="grid grid-flow-col items-center gap-[10px] text-[12px] capitalize">
                      {item.label}
                    </section>
                  </MenuItem>
                ))}
              </Menu>
              <div className="mr-[24px] ml-[24px] hidden h-[20px]  self-center border-l-[1px] border-[#fff] border-opacity-[0.2] md:block"></div>
              <span className=" ml-[70px] mb-[10px] flex items-center md:ml-[0px] md:mb-[0px]">
                <span className="mr-[10px] hidden md:block">
                  {t<string>("context.private.screens.offers.timezone")}:
                </span>

                <ClockIcon fill="#FFBD2E" />
                <span className="ml-[5px] mr-[10px] font-[700] text-white">
                  {user?.timezone?.abbreviation}, {offset ?? ""}
                </span>
              </span>
            </div>
          </section>
        </section>
      </div>{" "}
      <Modal
        open={isOpen}
        onClose={close}
        content={<DefaultViewOptions onClose={close} />}
        classNames={{
          content: "overflow-y-auto overflow-x-hidden p-0",
          paper: "rounded-[5px] min-w-[362px]",
        }}
      />
    </React.Fragment>
  );
};
